<template>
  <div class='info'>
    <navigator :title="navtital" :routePath='"/"'></navigator>
    <div class="btn">
      <mt-button class="myButton" @click="onAdd" size="small">+添加发票信息</mt-button>
    </div>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <van-panel title="发票信息" class="invoice-list" v-for="(item, index) in invoice_list" :key='index'>
        <van-row class="invoice-item">
          <van-col class="left" span="8">发票类型：</van-col>
          <van-col class="right" span="14" offset="2">{{item.invoiceType===2?'增值税发票':'普通发票'}}</van-col>
        </van-row>
        <van-row class="invoice-item">
          <van-col class="left" span="8">发票抬头：</van-col>
          <van-col class="right" span="14" offset="2">{{item.invoiceTitle}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2 || item.type===1">
          <van-col class="left" span="8">纳税人识别号：</van-col>
          <van-col class="right" span="14" offset="2">{{item.creditCode}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">注册地址：</van-col>
          <van-col class="right" span="14" offset="2">{{item.registerAddress}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">注册电话：</van-col>
          <van-col class="right" span="14" offset="2">{{item.registerTel}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">开户银行：</van-col>
          <van-col class="right" span="14" offset="2">{{item.bankName}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">银行账号：</van-col>
          <van-col class="right" span="14" offset="2">{{item.bankAccount}}</van-col>
        </van-row>
        <van-row class="invoice-item">
          <van-col class="left" span="8">收票人手机：</van-col>
          <van-col class="right" span="14" offset="2">{{item.receiverMobile ===''?'--':item.receiverMobile}}</van-col>
        </van-row>
        <div slot="footer">
          <van-button size="small" @click="onModify(item)">修改</van-button>
          <van-button size="small" @click="onDelete(item.invoiceId)">删除</van-button>
        </div>
      </van-panel>
    </van-list>
  </div>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Dialog } from 'vant';
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Dialog);

export default {
  data() {
    return {
      invoiceId: 0,
      add: '',
      invoice_type: 'normal',
      loading: false,
      finished: false,
      activeName: "normal",
      pageIndex: 1,
      invoice_list: [],
      totalPage: 0,
      navtital: '发票管理',
    };
  },
  methods: {
    onChange(){
      this.normalForm.phone = '';
      this.normalForm.id = '';
      this.normalForm.title = '';
    },
    onAdd(){
      this.$router.push(`/personal/addinvoice`);
    },
    onModify(e){
      this.$router.push(`/personal/modifyinvoice?invoiceId=${e.invoiceId}`);
    },
    onDelete(e){
      Dialog.confirm({
        title: '提示',
        message: '确认删除此发票？',
      }).then(() => {
        this.$http.post(`${this.URL_PREFIX}/app/delete/user/invoice/info`,{
          invoiceId: e,
        },{
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            Toast('删除成功');
            this.getList();
          }else{
            Toast('删除失败');
          }
        })
      }).catch(() => {});
    },
    getList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.totalPage = res.data.resData.length>0?res.data.resData.pageInfo.total:0;
          let pageList = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.invoice_list = this.invoice_list.concat(pageList);
          this.finished = this.invoice_list.length >= this.totalPage ? true : false;
        }else{
          Toast(res.data.resDesc);
        }
        this.loading = false;
      })
    },
    loadMore() {
      if (this.invoice_list.length >= this.totalPage) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getList();
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    if (!this.token) {
      this.$root.eventHub.$emit('login', this.$route.fullPath);
    } else {
    }
  },
  mounted() {
    this.getList();
  },
};
</script>


<style lang="scss" scoped>
@import '~@scss';
.info{
  width: 100%;
  background: #efefef;
  .btn{
    background: #fff;
    padding-bottom: 8px;
    .myButton{
      width: 50%;
      margin-left: 25%;
    }
  }
  .invoice-list{
    border-bottom: 1px solid #ccc;
    margin-top: 8px;
    padding-left: 16px;
    .invoice-item{
      font-size: 14px;
      color: #666;
      margin: 0.33rem 0.1rem;
      .left{
        text-align: right;
      }
      .right{
        color: #000;
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/pages/personal/Invoice.vue